module.exports = __webpack_public_path__ + "static/img/3-2.ded0260.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3-2.jpg
// module id = aNNe
// module chunks = 0